import { CashoutErrorCode } from 'app/lib/staking/constants';

// ---

type StakeId = number;
export type BigCashOutErrors = Record<StakeId, CashoutErrorCode> | null;

export const CASH_OUT_ERRORS_STORAGE_KEY = 'cash-out-errors-storage';

// ---

function createStorageKey(clientId: string) {
  return `${CASH_OUT_ERRORS_STORAGE_KEY }_${clientId}`;
}

export function getBigCashOutErrors(clientId: string): BigCashOutErrors {
  const data = localStorage.getItem(createStorageKey(clientId));

  if (!data) {
    return null;
  }

  return JSON.parse(data);
}

export function saveBigCashOutError(
  clientId: string,
  stakeId: StakeId,
  errorCode?: CashoutErrorCode | null,
) {
  const currentErrors = getBigCashOutErrors(clientId) || {};

  if (stakeId in currentErrors) {
    console.error(`
      Stake with id (${stakeId}) already exist with code: ${currentErrors[stakeId]}.
      This error will be replaced on new error with code: ${errorCode}.
    `);
  }

  const code = typeof errorCode === 'number'
    ? errorCode
    : CashoutErrorCode.INTERNAL_SERVER_ERROR;

  const key = createStorageKey(clientId);
  const value = JSON.stringify({ ...currentErrors, [stakeId]: code });

  localStorage.setItem(key, value);
}

export function removeBigCashOutError(clientId: string, stakeId: StakeId) {
  const currentErrors = getBigCashOutErrors(clientId);

  if (!currentErrors || !(stakeId in currentErrors)) {
    return;
  }

  const clonedErrors = { ...currentErrors };
  delete clonedErrors[stakeId];

  const key = createStorageKey(clientId);
  const value = JSON.stringify(clonedErrors);

  localStorage.setItem(key, value);
}
